import { render, staticRenderFns } from "./NewProjectBundles.vue?vue&type=template&id=a58e318e&scoped=true"
import script from "./NewProjectBundles.vue?vue&type=script&lang=js"
export * from "./NewProjectBundles.vue?vue&type=script&lang=js"
import style0 from "./NewProjectBundles.vue?vue&type=style&index=0&id=a58e318e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58e318e",
  null
  
)

export default component.exports